var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag-svg-with-color",domProps:{"innerHTML":_vm._s(_vm.getSvgWithColor(_vm.tag))}})
}
var staticRenderFns = []

export { render, staticRenderFns }